export default {
  title: 'Your security questions have been updated.',
  information: 'You can use your answers right now.',
};
